import React from 'react';
import { Box, Typography, Container, CircularProgress } from '@mui/material';
import { Schedule } from '@mui/icons-material';

const PaymentPendingPage: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          py: 4,
        }}
      >
        <Schedule
          sx={{
            fontSize: 80,
            color: 'warning.main',
            mb: 3,
          }}
        />

        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            mb: 2,
            fontSize: { xs: '1.75rem', md: '2.125rem' },
          }}
        >
          Pago en proceso
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mb: 4,
            maxWidth: 400,
            lineHeight: 1.6,
            fontSize: '1.1rem',
          }}
        >
          Tu pago está siendo procesado. Te notificaremos por correo electrónico
          una vez que se complete.
        </Typography>

        <CircularProgress
          sx={{
            color: 'warning.main',
            mb: 2,
          }}
        />

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            fontStyle: 'italic',
          }}
        >
          Este proceso puede tardar unos minutos...
        </Typography>
      </Box>
    </Container>
  );
};

export default PaymentPendingPage;
